import React, { useState } from "react";
import {
  Button,
  FlexRowBetween,
  GenericDiv,
  Input,
  Label,
  PopupForm,
  TextArea,
} from "../../common/Style";
import { useForm } from "react-hook-form";
import { CFV } from "../../common/others/Functions";
import OpacityLoading from "../../common/loader/OpacityLoading";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { deleteF, edit } from "../../../store/reducers/todosReducer";
import GCalendar from "../../common/calendar/Calendar";
import GenericModal from "../../common/modals/GenericModal";
import trash from "../../../assets/common/trash.svg";
import YesNoModal from "../../common/modals/YesNoModal";
import {
  ROLE_6_MESSAGE_TYPES,
  getExistingLabelsInSchedule,
  validateRole6ReminderAndThankDate,
  validateRole6TaskOrder,
} from "./Add";

const MSG_SCHEDULED_NO_EDIT_DATE =
  "לא ניתן לערוך משימה מתוזמנת. יש למחוק את התיזמון ורק אז לערוך את המשימה.";
const MSG_SCHEDULED_NO_DELETE =
  "לא ניתן למחוק משימה מתוזמנת. יש לבטל קודם את התזמון ורק אז למחוק את המשימה.";

const Edit = ({ todo, init, userRole, isTal, eventDate }) => {
  const dispatch = useDispatch();
  const { todos, todosLoading } = useSelector((state) => state.todosReducer);
  const isScheduled = !!(todo.ScheduledRequestUid != null && todo.ScheduledRequestUid !== "");
  const isRole6 = userRole === 6 || (userRole === 1 && isTal);
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      title: todo.title || "",
      description: todo.description || "",
    },
  });
  const currentTitle = watch("title");
  const selectedPresetId = isRole6
    ? (ROLE_6_MESSAGE_TYPES.find((t) => currentTitle && currentTitle.trim() === t.label)?.id ?? "")
    : "";
  const [showCalendar, setShowCalendar] = useState(null);
  const [showDelete, setShowDelete] = useState(null);
  const [showScheduledBlockModal, setShowScheduledBlockModal] = useState(false);
  const [scheduledBlockMessage, setScheduledBlockMessage] = useState("");

  const [date, setDate] = useState(new Date(todo.executionDate));
  const existingLabelsInSchedule =
    isRole6 ? getExistingLabelsInSchedule(todos, todo._id) : new Set();

  const handleSetDate = (e) => {
    let date1 = e;
    date1.setHours(20);
    setDate(date1);
  };

  const handleDateFieldClick = () => {
    if (isScheduled) {
      setScheduledBlockMessage(MSG_SCHEDULED_NO_EDIT_DATE);
      setShowScheduledBlockModal(true);
      return;
    }
    setShowCalendar(true);
  };

  const onSubmit = async (data) => {
    if (isScheduled) {
      const originalDateStr = new Date(todo.executionDate).toISOString().slice(0, 10);
      const newDateStr = date.toISOString().slice(0, 10);
      if (originalDateStr !== newDateStr) {
        toast.warning(MSG_SCHEDULED_NO_EDIT_DATE);
        return;
      }
    }
    if (isRole6) {
      const trimmedTitle = (data.title || "").trim();
      if (!trimmedTitle) {
        toast.warning("יש להזין כותרת");
        return;
      }
      if (!isTal) {
        const allowedLabels = ROLE_6_MESSAGE_TYPES.map((t) => t.label);
        if (!allowedLabels.includes(trimmedTitle)) {
          toast.warning("יש לבחור סוג הודעה מהרשימה");
          return;
        }
      }
      const labelsFromList = new Set(ROLE_6_MESSAGE_TYPES.map((t) => t.label));
      if (labelsFromList.has(trimmedTitle) && existingLabelsInSchedule.has(trimmedTitle)) {
        toast.warning(`משימה מסוג "${trimmedTitle}" כבר קיימת בלו\"ז`);
        return;
      }
      const dateCheck = validateRole6ReminderAndThankDate(
        eventDate,
        date.toISOString(),
        trimmedTitle
      );
      if (!dateCheck.valid) {
        toast.warning(dateCheck.message);
        return;
      }
      const orderCheck = validateRole6TaskOrder(
        todos,
        date.toISOString(),
        trimmedTitle,
        todo._id
      );
      if (!orderCheck.valid) {
        toast.warning(orderCheck.message);
        return;
      }
    }
    const body = { ...data, executionDate: date.toISOString() };
    dispatch(edit(todo._id, body)).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
        init();
      } else toast.error(res.payload?.error);
    });
  };

  const handleDeleteClick = () => {
    if (isScheduled) {
      setScheduledBlockMessage(MSG_SCHEDULED_NO_DELETE);
      setShowScheduledBlockModal(true);
      return;
    }
    setShowDelete(true);
  };

  const handleDelete = () => {
    dispatch(deleteF(todo._id)).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
        init();
      } else toast.error(res.payload?.error);
    });
  };

  return (
    <PopupForm
      onClick={(e) => e.stopPropagation()}
      onSubmit={handleSubmit(onSubmit)}
      className="animate__animated animate__fadeIn"
    >
      <div
        style={{
          width: "90%",
          margin: "15px auto",
        }}
      >
        <Label>כותרת</Label>
        {isRole6 ? (
          isTal ? (
            <>
              <Input
                type="text"
                {...register("title", {
                  required: true,
                  minLength: 2,
                  maxLength: 50,
                })}
              />
              <Label style={{ marginTop: "12px", display: "block" }}>
                בחירה מהירה מהרשימה
              </Label>
              <select
                value={selectedPresetId}
                onChange={(e) => {
                  const id = e.target.value;
                  const option = ROLE_6_MESSAGE_TYPES.find((t) => t.id === id);
                  if (option) setValue("title", option.label, { shouldValidate: true });
                }}
                style={{
                  width: "100%",
                  padding: "10px 12px",
                  fontSize: "16px",
                  border: "1px solid #ddd",
                  borderRadius: "6px",
                  backgroundColor: "#fff",
                  marginBottom: "8px",
                }}
              >
                <option value="">— בחר להזין כותרת —</option>
                {ROLE_6_MESSAGE_TYPES.map((type) => {
                  const disabled = existingLabelsInSchedule.has(type.label);
                  return (
                    <option key={type.id} value={type.id} disabled={disabled}>
                      {type.label}
                      {disabled ? " (קיים בלו\"ז)" : ""}
                    </option>
                  );
                })}
              </select>
            </>
          ) : (
            <select
              value={selectedPresetId}
              onChange={(e) => {
                const id = e.target.value;
                const option = ROLE_6_MESSAGE_TYPES.find((t) => t.id === id);
                if (option) setValue("title", option.label, { shouldValidate: true });
              }}
              style={{
                width: "100%",
                padding: "10px 12px",
                fontSize: "16px",
                border: "1px solid #ddd",
                borderRadius: "6px",
                backgroundColor: "#fff",
                marginBottom: "8px",
              }}
            >
              <option value="">— בחר סוג הודעה —</option>
              {ROLE_6_MESSAGE_TYPES.map((type) => {
                const disabled = existingLabelsInSchedule.has(type.label);
                return (
                  <option key={type.id} value={type.id} disabled={disabled}>
                    {type.label}
                    {disabled ? " (קיים בלו\"ז)" : ""}
                  </option>
                );
              })}
            </select>
          )
        ) : (
          <Input
            type="text"
            {...register("title", {
              required: true,
              minLength: 2,
              maxLength: 50,
            })}
          />
        )}
        {CFV("title", "בין 2 ל 50 תווים", errors)}

        <Label>הערות</Label>
        <TextArea
          defaultValue={todo.description}
          type="text"
          rows="3"
          {...register("description", {
            minLength: 0,
            maxLength: 500,
          })}
        />
        {CFV("description", "עד 500 תווים", errors)}

        <Label>תאריך לביצוע</Label>
        <Input
          onClick={handleDateFieldClick}
          value={date
            .toISOString()
            .replace(/T.*/, "")
            .split("-")
            .reverse()
            .join("/")}
          onChange={() => {}}
          type={"text"}
        />
        <FlexRowBetween style={{ marginTop: "50px" }}>
          <Button style={{ width: "100%" }}>שמירה</Button>
          <GenericDiv
            onClick={handleDeleteClick}
            background={"rgba(41,59,90,0.95)"}
            style={{ marginRight: "20px", padding: "9px 10px" }}
          >
            <img src={trash} alt="trash" style={{ width: "21px" }} />
          </GenericDiv>
        </FlexRowBetween>
      </div>

      {todosLoading && <OpacityLoading />}

      {showCalendar && (
        <GenericModal
          init={setShowCalendar}
          div={
            <GCalendar
              setDate={handleSetDate}
              date={date}
              init={setShowCalendar}
            />
          }
        />
      )}

      {showDelete && (
        <GenericModal
          init={setShowDelete}
          div={
            <YesNoModal
              title={"מחיקת משימה"}
              body={"האם את/ה בטוח/ה שברצונך למחוק משימה זו?"}
              no={setShowDelete}
              yes={handleDelete}
            />
          }
        />
      )}

      {showScheduledBlockModal && (
        <GenericModal
          init={() => setShowScheduledBlockModal(false)}
          div={
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                padding: "24px",
                minWidth: "280px",
                background: "#fff",
                borderRadius: "12px",
                border: "2px solid #7b96c4",
                textAlign: "center",
              }}
            >
              <p style={{ marginBottom: "20px", fontSize: "16px", lineHeight: 1.5 }}>
                {scheduledBlockMessage}
              </p>
              <Button onClick={() => setShowScheduledBlockModal(false)}>הבנתי</Button>
            </div>
          }
        />
      )}
    </PopupForm>
  );
};

export default Edit;
